const e = { aria_label: "Hae", clear: "Läpinäkyvä", placeholder_article: "", placeholder_header: "Hae artikkeleita" }, a = {
  searcher: e
};
export {
  a as default,
  e as searcher
};
//# sourceMappingURL=help-center-articles-search36.js.map
